var map = {
	"./de.json": 4544,
	"./en_GB.json": 4545,
	"./es.json": 4546,
	"./fr.json": 4547,
	"./it.json": 4548,
	"./ja.json": 4549,
	"./ko.json": 4550,
	"./nl.json": 4551,
	"./pl.json": 4552,
	"./pt_BR.json": 4553,
	"./ru.json": 4554,
	"./zh.json": 4555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4543;